import "../stylesheets/loadingScreen.css";

const LoadingScreen = () => {
  return (
    <div className="loading-container">
      <div className="loading"></div>
    </div>
  );
};

export default LoadingScreen;
